import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/referral/guestpass.png")